import cn from "classnames"

import { Text } from "ui-kit/components-branded/index"
import style from "components/Header/components/TheDot/thedot.module.scss"

export function TheDot() {
    return (
        <Text isAccent className={cn("has-text-dark-30 is-inline-block", style.container)}>
            •
        </Text>
    )
}
